import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/services/app-listing"
    path="business/services/app-listing"
    element={<AsyncPage />}
  />,
];
